import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import styles from './Carousel.module.scss';
const CarouselItem = ({ title, description }) => {
    return (_jsxs("li", { className: styles.carousel__item, children: [_jsx("h3", { className: styles.carousel__itemTitle, children: title }), _jsx("p", { className: styles.carousel__itemDescription, children: description })] }));
};
const Carousel = ({ items }) => {
    const listRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    useEffect(() => {
        handleScroll();
    }, []);
    const scroll = (direction) => {
        if (!listRef.current)
            return;
        const scrollAmount = 232;
        const currentScroll = listRef.current.scrollLeft;
        if (direction === 'left') {
            listRef.current.scrollTo({
                left: currentScroll - scrollAmount,
                behavior: 'smooth',
            });
        }
        else {
            listRef.current.scrollTo({
                left: currentScroll + scrollAmount,
                behavior: 'smooth',
            });
        }
    };
    const handleScroll = () => {
        if (!listRef.current)
            return;
        const { scrollLeft, scrollWidth, clientWidth } = listRef.current;
        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    };
    return (_jsxs("section", { className: styles.carousel__wrapper, "aria-labelledby": "carousel-heading", children: [_jsx("h2", { id: "carousel-heading", className: styles.carousel__title, children: "View the best in vet tech for treating..." }), _jsxs("div", { className: styles.carousel__listContainer, children: [showLeftArrow && (_jsx("button", { className: `${styles.carousel__navButton} ${styles['carousel__navButton--left']}`, onClick: () => scroll('left'), "aria-label": "Scroll left", children: _jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M15 18L9 12L15 6", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }) })), _jsx("ul", { ref: listRef, className: styles.carousel__list, role: "list", onScroll: handleScroll, children: items.map((item, index) => (_jsx(CarouselItem, { title: item.title, description: item.description }, `${item.title}-${index}`))) }), showRightArrow && (_jsx("button", { className: `${styles.carousel__navButton} ${styles['carousel__navButton--right']}`, onClick: () => scroll('right'), "aria-label": "Scroll right", children: _jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M9 6L15 12L9 18", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }) }))] })] }));
};
export default Carousel;
